<template>
  <BootstrapModal :show="showModal" :trigger-class=triggerClass :trigger-icon=triggerIcon :triggerText=triggerText
                  submit-btn="Speichern" title="Abmeldung erstellen" @close="handleClose" @open="handleOpen"
                  @save="addAbsence">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="altarServer">Messdiener:in</label>
          <multiselect id="altarServer" v-model="this.absence.altarServer"
                       :custom-label="this.altarServerStore.getPlannameById"
                       :multiple="false"
                       :options="this.altarServerStore.getIDs"></multiselect>
        </div>
        <div class="col">
          <label class="form-label" for="startDate">Start-Datum</label>
          <input id="startDate" v-model="this.absence.startDate" class="form-control" placeholder="Start-Datum"
                 required type="date">
        </div>
        <div class="col">
          <label class="form-label" for="endDate">End-Datum</label>
          <input id="endDate" v-model="this.absence.endDate" class="form-control" placeholder="End-Datum" required
                 type="date">
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapModal from "@/components/BootstrapModal";
import {useAltarServerStore} from "@/stores/altarServer";
import {useAbsenceStore} from "@/stores/absence";

export default {
  name: "AbsenceCreateModal",
  props: ['altarServerId', 'triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      absence: {},
      showModal: false
    }
  },
  methods: {
    handleOpen() {
      this.showModal = true;
      this.absence = {
        altarServer: this.altarServerId
      }
    },
    handleClose() {
      this.showModal = false;
      this.absence = {};
    },
    addAbsence() {
      this.absenceStore.addItem(this.absence);
      this.handleClose();
    }
  },
  components: {
    BootstrapModal,
    Multiselect
  },
  created() {
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    const absenceStore = useAbsenceStore();
    return {altarServerStore, absenceStore};
  }
}
</script>
